<template>
  <div class="row full-height">
    <el-row>
      <el-col :span="24" style="overflow: scroll;">
        
        <el-col :span="24" class="right-panel">
          <MainContent />
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
// import MessagePanelComponent from "./MessagePanel";
import MainContent from "./MainContent";
export default {
  name: "MainComponent",
  components: {
    // MessagePanelComponent,
    MainContent
  },
  data() {
    return {
      search: "",
    };
  },
};
</script>

<style></style>
